<template>

    <div class="document-acceptance-component order-form-component">

        <div class="introduction">
            <div class="row mb-0">
                <div class="col-12">
                    <h3>4. Document Acceptance</h3>
                    <p>Below you are presented with the key documents related to your vehicle order. You must review and
                        confirm your acceptance using the toggle shown at the end of each document. Acceptance of these
                        documents allows you to submit your vehicle order.</p>
                </div>
            </div>
        </div>

        <div class="card">
            <policy-component :policy="policy" @policyToggled="toggleAcceptPolicy"/>
        </div>

<!--        <div class="agree">-->
<!--            <input type="checkbox" name="website-and-communications-privacy-notice"-->
<!--                   id="website-and-communications-privacy-notice" class="website-and-communications-privacy-notice"-->
<!--                   v-model="confirmations.privacyNotice">-->
<!--            <label for="website-and-communications-privacy-notice">I confirm that I have read and accept the &nbsp;<strong>Website-->
<!--                & Communications Privacy Notice</strong></label>-->
<!--        </div>-->

    </div>

</template>
<script>
import {EventBus} from '@/event-bus.js';

export default {

    props: [
        'confirmations',
    ],

    data () {
        return {
            policy: null,
            policyAccepted: false,
            alreadyAccepted: false
        }
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.get();
        })
    },

    watch: {
        confirmations: {
            handler(confirmations) {
                for (const [key, value] of Object.entries(confirmations)) {
                    this.$parent.confirmations[key] = value;
                }
            },
            deep: true
        },
    },

    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        }

        if (!this.policyAccepted || !this.confirmations.privacyNotice){
            EventBus.$emit('loading', false);
            EventBus.$emit('showError', true);
            EventBus.$emit('errorTitle', 'Please agree all points to continue');
            return false;
        }

        if (this.alreadyAccepted && this.confirmations.privacyNotice) {
            EventBus.$emit('loading', false);
            return next();
        }

        this.$http.post('/api/accept-document',
            {
                accept: true,
                quotePolicyID: this.policy.quotePolicyID
            })
            .then(response => {
                EventBus.$emit('loading', false);
                if(response.data.data.accepted) {
                    next();
                }
            })
            .catch(err => {
                EventBus.$emit('loading', false);
                let response = err.response;

                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: 'Error',
                    text: response.message
                });
                this.error = err.message.toString();
                this.$router.push({ name: response.redirect });
            });


        next();
    },

    methods: {
        toggleAcceptPolicy() {
            this.privacyAccepted = !this.privacyAccepted;
            this.confirmations.privacyNotice = !this.confirmations.privacyNotice;
        },
        get() {

            EventBus.$emit('loadingTitle', 'Fetching Policies');
            EventBus.$emit('loading', true);

            this.$http.get('/api/privacy-statement')
                .then(response => {
                    EventBus.$emit('loading', false);
                    this.policiesAccepted = response.data.session.policiesAccepted;
                    this.$parent.policiesAccepted = this.policiesAccepted;
                    this.alreadyAccepted = this.policiesAccepted
                    this.policy = response.data.data;
                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.message
                    });
                    this.error = err.message.toString();
                    this.$router.push({ name: response.redirect });
                });
        }
    }
}
</script>
